import InfiniteScroll from 'infinite-scroll';

import componentRenderService from '../services/component-render.service';
import AudioListItemPlayer from '../react/renders/audio-list-item-player';

const pageFeedEl = document.querySelector('.page-feed');

if (pageFeedEl) {
  new InfiniteScroll(pageFeedEl, {
    path: '.pagination .page-link-next',
    append: '.audio-feed-items > .feed-list-item',
    history: false,
  });
  /* Activate .audio-list-item-player on added elements: */
  new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((audioListItemEl) => {
          componentRenderService.byElement(
            audioListItemEl.querySelector('.audio-list-item-player'),
            AudioListItemPlayer
          );
        });
      }
    }
  }).observe(pageFeedEl, {
    childList: true,
  });
}
